import View from './View';

export { default as View, getModalStyles } from './View';
export const useViewModel = (props) => props;

export default View;
